const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');

class SnapStoreFeedChannel extends ChannelDefinition {
	id = 'snap-store-feed';
	title = 'Snap Store Feed';
	description = 'Connect with a younger audience by showcasing your products on Snapchat.';
	category = Categories.SOCIAL_COMMERCE;
	iconUrl = 'https://images.near.st/channels/snapchat.svg';
	tag = 'Beta';
	comingSoon = true;
	feedExport = true;

	worksWith = ['storefront'];

	longDescription = `
## Overview
Connect your product inventory to Snap Store and make your products available to Snapchat's engaged audience. Reach local shoppers through one of the most popular social platforms.

## How it works
NearSt generates a product feed from your live inventory that can be used to power your Snap Store catalogue. Contact our support team to get set up.

## Requirements
- An active NearSt inventory connection
- A Snapchat Business account
- Product data (titles, descriptions, and images) for your inventory
- Product page links for each product — either from your own website or via a NearSt Storefront

Please check the catalogue setup instructions provided by Snapchat for up-to-date information on getting your products live using this feed.
	`;
}

module.exports = SnapStoreFeedChannel;
